import { render, staticRenderFns } from "./MwDialog.vue?vue&type=template&id=685cca68&"
import script from "./MwDialog.vue?vue&type=script&lang=js&"
export * from "./MwDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports